module.exports = __webpack_public_path__ + "0a9712b4e613af2c1bdc2f7dea03b95e.svg";